import type { WidgetPublicState } from "@/types";
import { useWidgetStore } from "@/state";

export function subscribePublicState(cb: (s: WidgetPublicState) => void) {
  cb(useWidgetStore.getState().state);

  return useWidgetStore.subscribe(
    (s) => s.state,
    (next) => cb(next)
  );
}
